module.exports = __webpack_public_path__ + "img/fdngiudfgidhfi.a4b5534c.png";